import { createSharedComposable } from "@vueuse/core";
import { onScopeDispose, readonly, ref } from "vue";

function convertRemToPixels(rem: number) {
	return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export type BeakpointType = "mobile" | "desktop";

export function onBreakpointChange(cb: (t: BeakpointType) => void) {
	const breakpointStr = window.getComputedStyle(document.body).getPropertyValue("--breakpoint-md");

	let breakpoint: number;
	if (breakpointStr.endsWith("rem")) {
		breakpoint = convertRemToPixels(parseFloat(breakpointStr));
	} else {
		breakpoint = parseFloat(breakpointStr);
	}

	const onChange = () => {
		const type: BeakpointType = window.innerWidth < breakpoint ? "mobile" : "desktop";
		cb(type);
	};

	const mql = window.matchMedia(`(width >= ${breakpoint}px`);
	onChange();

	mql.addEventListener("change", onChange);

	return () => mql.removeEventListener("change", onChange);
}

export const useIsMobile = createSharedComposable(() => {
	const isMobile = ref(false);

	const stop = onBreakpointChange((t) => {
		isMobile.value = t === "mobile";
	});

	onScopeDispose(stop);

	return readonly(isMobile);
});
